import { ProductRowViewModel, ProductSalesUnitViewModel } from "../types/productListView.types";
import { ProductClimateImpactFormatter } from "./ClimateImpactFormatter";

/**
 * Single-responsibility mapper: turns one raw `/V2/products` API record into
 * the typed `ProductRowViewModel` the presentation layer renders.
 *
 * Mirrors the inline mapping in the legacy `ProductList` render (see
 * src/screens/product/productList/ProductList.tsx) exactly, so the grid
 * keeps showing the same data — only the shaping logic moved into its own,
 * independently testable unit, same split as `IngredientRowMapper` in
 * src/screens/lcaIngredients/ingredientList/services/.
 */
export class ProductRowMapper {
  static toSalesUnitViewModel(unit: any, isUserSupplier: boolean): ProductSalesUnitViewModel {
    return {
      id: unit?._id,
      name: unit?.sales_unit_name || "-",
      eanBarcode: unit?.ean_barcode || "-",
      climateImpactText: ProductClimateImpactFormatter.formatSalesUnit(
        unit?.climate_impact,
        isUserSupplier
      )
    };
  }

  static toRowViewModel(product: any, isUserSupplier: boolean): ProductRowViewModel {
    const isAverageProduct = product?.is_average_product || false;
    return {
      product_id: product?._id,
      product_name: product?.product_name,
      registerNumber: product?.registration_number || "-",
      productType: product?.product_type || "-",
      isAverageProduct,
      averageImpactStatusText: isAverageProduct ? "Yes" : "No",
      averageClimateImpactText: ProductClimateImpactFormatter.formatAverage(
        product?.linkedSalesUnitsAverageClimateImpact
      ),
      salesUnits: (product?.sales_units || []).map((unit: any) =>
        ProductRowMapper.toSalesUnitViewModel(unit, isUserSupplier)
      ),
      hasSalesUnits: (product?.sales_units?.length || 0) > 0
    };
  }

  static toRowViewModels(products: any[] | undefined, isUserSupplier: boolean): ProductRowViewModel[] {
    return (products || []).map(product => ProductRowMapper.toRowViewModel(product, isUserSupplier));
  }
}
